import React from "react";
import cezLogo from "../../assets/cez/cez-logo.png";

function CezLogo({ className = "h-12 w-12", title = "CEZ" }) {
  return (
    <img
      src={cezLogo}
      alt={title}
      title={title}
      className={`object-contain bg-white rounded-full ${className}`}
    />
  );
}

export default CezLogo;
